import React, { useState, useEffect } from "react";
import { Lock, Menu, X, Users, Settings, LogOut } from "lucide-react";
import { BrowserRouter, Route, Routes, useNavigate } from "react-router-dom";
//, Navigate
import ComingSoon from "./public/ComingSoon";
import { loadSavedTheme } from "./utils/themes";
import { loadSavedFont } from "./utils/fonts";
import Maintenance from "./public/Maintenance";
// import { NavigationService } from "./NavigationService";
import { useAuth } from "./auth/context";
import { AuthProvider } from "./auth/AuthProvider";
//import Start from "./public/Start";
import About from "./public/About";
import Contact from "./public/Contact";
import Login from "./public/Login";
import Privacy from "./public/Privacy";
import Terms from "./public/Terms";
import Register from "./public/Register";
import PasswordReset from "./public/PasswordReset";
import VerifyEmail from "./public/VerifyEmail";
import EmailVerificationComplete from "./public/EmailVerificationComplete";
import Tour from "./private/Tour";
import UserSettings from "./private/UserSettings";
import EntryPoint from "./private/EntryPoint";
import { NavigationService } from "./NavigationService";
import Home from "./public/Home";
import Gaming from "./public/Gaming";
import Games from "./private/Games";
import SubscriptionUpdate from "./private/SubscriptionUpdate";
import CreateRule from "./private/CreateRule";
import Subscribe from "./private/Subscribe";
import Help from "./private/Help";
import Rules from "./private/Rules";
import DeleteAccount from "./private/DeleteAccount";
import Support from "./public/Support";
import UpdateMessageBanner from "./components/UpdateMessageBanner";
//import MultiLineChart from "./private/GameDetail";
import GameDetails from "./private/GameDetails";
import GameProps from "./private/GameProps";
import PropDetails from "./private/PropDetails";
import AdvantageBetting from "./private/AdvantageBetting";
//import MultiLineChart from "./private/GameDetail";
//import { useAuth, AuthProvider } from "./AuthContext";
// App types
// interface User {
//   id: string;
//   email: string;
//   name: string;
//   role: string;
//   avatar?: string;
//   emailVerified: boolean;
// }

// interface AuthContextType {
//   user: User | null;
//   login: (email: string, password: string) => Promise<User>;
//   loginWithGoogle: () => Promise<User>;
//   logout: () => Promise<void>;
//   loading: boolean;
// }

// interface AuthProviderProps {
//   children: ReactNode;
// }

interface NavItem {
  name: string;
  icon: React.ComponentType<{ className?: string }>;
  href: string;
}

// // Firebase configuration - Replace with your actual Firebase config
// const firebaseConfig = {
//   apiKey: "your-api-key-here",
//   authDomain: "your-project.firebaseapp.com",
//   projectId: "your-project-id",
//   storageBucket: "your-project.appspot.com",
//   messagingSenderId: "123456789012",
//   appId: "1:123456789012:web:abcdef123456789",
// };

// // Initialize Firebase
// const app = initializeApp(firebaseConfig);
// const auth = getAuth(app);
// const googleProvider = new GoogleAuthProvider();

// // Configure Google provider scopes
// googleProvider.addScope("profile");
// googleProvider.addScope("email");

// // Authentication Context
// const AuthContext = createContext<AuthContextType | undefined>(undefined);

// const useAuth = (): AuthContextType => {
//   const context = useContext(AuthContext);
//   if (!context) {
//     throw new Error("useAuth must be used within an AuthProvider");
//   }
//   return context;
// };

// // Helper function to convert Firebase user to app user
// const convertFirebaseUser = (firebaseUser: FirebaseUser): User => {
//   return {
//     id: firebaseUser.uid,
//     email: firebaseUser.email || "",
//     name:
//       firebaseUser.displayName || firebaseUser.email?.split("@")[0] || "User",
//     role: firebaseUser.email === "admin@company.com" ? "admin" : "user",
//     avatar: firebaseUser.photoURL || undefined,
//     emailVerified: firebaseUser.emailVerified,
//   };
// };

// // Helper function to convert Firebase error codes to user-friendly messages
// const getErrorMessage = (errorCode: string): string => {
//   switch (errorCode) {
//     case "auth/invalid-credential":
//     case "auth/invalid-email":
//     case "auth/user-not-found":
//     case "auth/wrong-password":
//       return "Invalid email or password";
//     case "auth/too-many-requests":
//       return "Too many failed attempts. Try again later";
//     case "auth/popup-closed-by-user":
//       return "Sign-in cancelled";
//     case "auth/popup-blocked":
//       return "Popup blocked. Please allow popups and try again";
//     case "auth/network-request-failed":
//       return "Network error. Please check your connection";
//     case "auth/email-already-in-use":
//       return "Email is already registered";
//     case "auth/weak-password":
//       return "Password should be at least 6 characters";
//     case "auth/user-disabled":
//       return "This account has been disabled";
//     case "auth/operation-not-allowed":
//       return "This sign-in method is not enabled";
//     case "auth/account-exists-with-different-credential":
//       return "Account exists with different sign-in method";
//     default:
//       return "An error occurred during authentication";
//   }
// };

// // Auth Provider Component
// const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
//   const [user, setUser] = useState<User | null>(null);
//   const [loading, setLoading] = useState<boolean>(true);

//   useEffect(() => {
//     // Listen for authentication state changes
//     const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
//       if (firebaseUser) {
//         const appUser = convertFirebaseUser(firebaseUser);
//         setUser(appUser);
//       } else {
//         setUser(null);
//       }
//       setLoading(false);
//     });

//     return () => unsubscribe();
//   }, []);

//   const login = async (email: string, password: string): Promise<User> => {
//     try {
//       const result: UserCredential = await signInWithEmailAndPassword(
//         auth,
//         email,
//         password
//       );
//       const appUser = convertFirebaseUser(result.user);
//       return appUser;
//     } catch (error) {
//       const authError = error as AuthError;
//       throw new Error(getErrorMessage(authError.code));
//     }
//   };

//   const loginWithGoogle = async (): Promise<User> => {
//     try {
//       const result: UserCredential = await signInWithPopup(
//         auth,
//         googleProvider
//       );
//       const appUser = convertFirebaseUser(result.user);
//       return appUser;
//     } catch (error) {
//       const authError = error as AuthError;
//       throw new Error(getErrorMessage(authError.code));
//     }
//   };

//   const logout = async (): Promise<void> => {
//     try {
//       await signOut(auth);
//     } catch (error) {
//       console.error("Logout error:", error);
//       throw new Error("Failed to sign out");
//     }
//   };

//   const value: AuthContextType = {
//     user,
//     login,
//     loginWithGoogle,
//     logout,
//     loading,
//   };

//   return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
// };

// Login Component
const LoginForm: React.FC = () => {
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [error, setError] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isGoogleLoading, setIsGoogleLoading] = useState<boolean>(false);
  const { login, loginWithGoogle } = useAuth();

  const handleSubmit = async (
    e: React.FormEvent<HTMLButtonElement>,
  ): Promise<void> => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    try {
      await login(email, password);
    } catch (err) {
      if (err instanceof Error) {
        setError(err.message);
      } else {
        setError("An unexpected error occurred");
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleGoogleLogin = async (): Promise<void> => {
    setError("");
    setIsGoogleLoading(true);

    try {
      await loginWithGoogle();
    } catch (err) {
      if (err instanceof Error) {
        setError(err.message);
      } else {
        setError("Google authentication failed");
      }
    } finally {
      setIsGoogleLoading(false);
    }
  };

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setEmail(e.target.value);
  };

  const handlePasswordChange = (
    e: React.ChangeEvent<HTMLInputElement>,
  ): void => {
    setPassword(e.target.value);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-xl p-8 w-full max-w-md">
        <div className="text-center mb-8">
          <div className="mx-auto w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mb-4">
            <Lock className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-2xl font-bold text-gray-900">Welcome Back</h1>
          <p className="text-gray-600 mt-2">Please sign in to your account</p>
        </div>

        <div className="space-y-6">
          {/* Google Sign In Button */}
          <button
            onClick={handleGoogleLogin}
            disabled={isGoogleLoading}
            className="w-full flex items-center justify-center px-4 py-2 border border-gray-300 rounded-md shadow-sm bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed transition duration-200"
          >
            {isGoogleLoading ? (
              <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-blue-600"></div>
            ) : (
              <>
                <svg className="w-5 h-5 mr-3" viewBox="0 0 24 24">
                  <path
                    fill="#4285F4"
                    d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                  />
                  <path
                    fill="#34A853"
                    d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                  />
                  <path
                    fill="#FBBC05"
                    d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                  />
                  <path
                    fill="#EA4335"
                    d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                  />
                </svg>
                Continue with Google
              </>
            )}
          </button>

          <div className="relative">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-gray-300" />
            </div>
            <div className="relative flex justify-center text-sm">
              <span className="px-2 bg-white text-gray-500">
                Or continue with email
              </span>
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Email Address
            </label>
            <input
              type="email"
              value={email}
              onChange={handleEmailChange}
              required
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              placeholder="your-email@example.com"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={handlePasswordChange}
              required
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              placeholder="Enter your password"
            />
          </div>

          {error && (
            <div className="text-red-600 text-sm text-center bg-red-50 p-3 rounded-md">
              {error}
            </div>
          )}

          <button
            onClick={handleSubmit}
            disabled={isLoading}
            className="w-full bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition duration-200"
          >
            {isLoading ? "Signing in..." : "Sign In"}
          </button>
        </div>

        <div className="mt-6 text-center text-sm text-gray-600">
          <p>Don't have an account? Contact your administrator.</p>
        </div>
      </div>
    </div>
  );
};

// Navigation Component
const Navigation: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState<boolean>(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const navItems: NavItem[] = [
    { name: "Dashboard", icon: Home, href: "#dashboard" },
    { name: "Team", icon: Users, href: "#team" },
    { name: "Settings", icon: Settings, href: "#settings" },
  ];

  const toggleMobileMenu = (): void => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleLogout = async (): Promise<void> => {
    try {
      await logout();
      navigate("/");
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  return (
    <nav className="bg-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <h1 className="text-xl font-bold text-gray-900">Your Business</h1>
            </div>
            <div className="hidden md:ml-6 md:flex md:space-x-8">
              {navItems.map((item: NavItem) => (
                <a
                  key={item.name}
                  href={item.href}
                  className="text-gray-600 hover:text-blue-600 px-3 py-2 rounded-md text-sm font-medium transition duration-200 flex items-center"
                >
                  <item.icon className="w-4 h-4 mr-2" />
                  {item.name}
                </a>
              ))}
            </div>
          </div>

          <div className="flex items-center">
            <div className="hidden md:flex md:items-center md:space-x-4">
              {user?.avatar && (
                <img
                  src={user.avatar}
                  alt={user.name}
                  className="w-8 h-8 rounded-full border-2 border-gray-200"
                />
              )}
              <div className="text-right">
                <p className="text-sm font-medium text-gray-700">
                  {user?.name}
                </p>
                <p className="text-xs text-gray-500">{user?.role}</p>
              </div>
              <button
                onClick={handleLogout}
                className="text-gray-600 hover:text-red-600 px-3 py-2 rounded-md text-sm font-medium transition duration-200 flex items-center"
              >
                <LogOut className="w-4 h-4 mr-2" />
                Logout
              </button>
            </div>

            <div className="md:hidden">
              <button
                onClick={toggleMobileMenu}
                className="text-gray-600 hover:text-gray-900 focus:outline-none focus:text-gray-900"
              >
                {isMobileMenuOpen ? (
                  <X className="w-6 h-6" />
                ) : (
                  <Menu className="w-6 h-6" />
                )}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 border-t">
              <div className="flex items-center px-3 py-2 mb-2">
                {user?.avatar && (
                  <img
                    src={user.avatar}
                    alt={user.name}
                    className="w-8 h-8 rounded-full border-2 border-gray-200 mr-3"
                  />
                )}
                <div>
                  <p className="text-sm font-medium text-gray-700">
                    {user?.name}
                  </p>
                  <p className="text-xs text-gray-500">{user?.role}</p>
                </div>
              </div>
              {navItems.map((item: NavItem) => (
                <a
                  key={item.name}
                  href={item.href}
                  className="text-gray-600 hover:text-blue-600 block px-3 py-2 rounded-md text-base font-medium flex items-center"
                >
                  <item.icon className="w-4 h-4 mr-2" />
                  {item.name}
                </a>
              ))}
              <button
                onClick={handleLogout}
                className="text-gray-600 hover:text-red-600 block w-full text-left px-3 py-2 rounded-md text-base font-medium flex items-center"
              >
                <LogOut className="w-4 h-4 mr-2" />
                Logout
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

// Main Dashboard Component
const Dashboard: React.FC = () => {
  const { user } = useAuth();

  return (
    <div className="min-h-screen bg-gray-50">
      <Navigation />

      <main className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        <div className="px-4 py-6 sm:px-0">
          <div className="border-4 border-dashed border-gray-200 rounded-lg p-8">
            <div className="text-center">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">
                Welcome to Your Business Dashboard
              </h2>
              <p className="text-gray-600 mb-4">
                Successfully authenticated with Firebase!
              </p>
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-8">
                <h3 className="text-lg font-semibold text-blue-900 mb-2">
                  User Information
                </h3>
                <div className="text-left space-y-1">
                  <p>
                    <span className="font-medium">ID:</span> {user?.id}
                  </p>
                  <p>
                    <span className="font-medium">Email:</span> {user?.email}
                  </p>
                  <p>
                    <span className="font-medium">Role:</span> {user?.role}
                  </p>
                  <p>
                    <span className="font-medium">Email Verified:</span>{" "}
                    {user?.emailVerified ? "✅ Yes" : "❌ No"}
                  </p>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="bg-white p-6 rounded-lg shadow">
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">
                    🔥 Firebase Ready
                  </h3>
                  <p className="text-gray-600 text-sm">
                    Production Firebase Auth with real authentication services
                  </p>
                </div>

                <div className="bg-white p-6 rounded-lg shadow">
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">
                    🔐 Secure
                  </h3>
                  <p className="text-gray-600 text-sm">
                    Enterprise-grade security with Google's authentication
                    infrastructure
                  </p>
                </div>

                <div className="bg-white p-6 rounded-lg shadow">
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">
                    📱 Responsive
                  </h3>
                  <p className="text-gray-600 text-sm">
                    Mobile-first design that works perfectly across all devices
                  </p>
                </div>
              </div>

              <div className="mt-8 bg-gray-100 rounded-lg p-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-3">
                  🚀 Next Steps
                </h3>
                <div className="text-sm text-gray-600 space-y-1">
                  <p>✅ Add your Firebase configuration</p>
                  <p>✅ Enable authentication methods in Firebase Console</p>
                  <p>✅ Deploy to your hosting platform</p>
                  <p>✅ Start building your business features</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

// Main App Component
const InnerApp: React.FC = () => {
  const { user, loading } = useAuth();
  const comingSoon = false;
  const maintenance = false;

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  // const ProtectedLogin = () => {
  //   return user ? (
  //     <Navigate to="/active_games" />
  //   ) : (
  //     <>
  //       <PageNav isLogin={true}></PageNav>
  //       <AuthPage initialMethod="login" />
  //       <Footer />
  //     </>
  //   );
  // };

  // const ProtectedRegister = () => {
  //   return user ? (
  //     <Navigate to="/tour" />
  //   ) : (
  //     <>
  //       <PageNav isRegister={true}></PageNav>
  //       <AuthPage initialMethod="register" />
  //       <Footer />
  //     </>
  //   );
  // };

  if (comingSoon) {
    return (
      <BrowserRouter>
        <NavigationService />
        <Routes>
          <Route path="/" element={<ComingSoon />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/responsible" element={<Gaming />} />
          <Route path="/support" element={<Support />} />
        </Routes>
      </BrowserRouter>
    );
  }

  if (maintenance) {
    return (
      <BrowserRouter>
        <NavigationService />
        <Routes>
          <Route path="/" element={<Maintenance />} />
        </Routes>
      </BrowserRouter>
    );
  }

  return (
    <BrowserRouter>
      <NavigationService />
      <main>
        <Routes>
          {/* <Route path="/" element={user ? <Home /> : <LoginForm />} /> */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/support" element={<Support />} />
          <Route path="/login" element={<Login />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/register" element={<Register />} />
          <Route path="/reset-password" element={<PasswordReset />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route
            path="/email-verified"
            element={<EmailVerificationComplete />}
          />
          <Route path="/terms" element={<Terms />} />
          <Route path="/responsible" element={<Gaming />} />
          <Route
            path="/tour"
            element={
              <EntryPoint path="/tour">
                <Tour />
              </EntryPoint>
            }
          />
          <Route
            path="/settings"
            element={
              <EntryPoint path="/settings">
                <UserSettings />
              </EntryPoint>
            }
          />
          <Route
            path="/games"
            element={
              <EntryPoint path="/games">
                <Games />
              </EntryPoint>
            }
          />
          <Route
            path="/game/:gameId"
            element={
              <EntryPoint path="/game/:gameId">
                <GameDetails />
              </EntryPoint>
            }
          />
          <Route
            path="/game/:gameId/props"
            element={
              <EntryPoint path="/game/:gameId/props">
                <GameProps />
              </EntryPoint>
            }
          />
          <Route
            path="/game/:gameId/props/chart"
            element={
              <EntryPoint path="/game/:gameId/props/chart">
                <PropDetails />
              </EntryPoint>
            }
          />
          <Route
            path="/advantage"
            element={
              <EntryPoint path="/advantage">
                <AdvantageBetting />
              </EntryPoint>
            }
          />
          <Route
            path="/help"
            element={
              <EntryPoint path="/help">
                <Help />
              </EntryPoint>
            }
          />
          <Route
            path="/rules"
            element={
              <EntryPoint path="/rules">
                <Rules />
              </EntryPoint>
            }
          />
          <Route
            path="/rule/create"
            element={
              <EntryPoint path="/rule/create">
                <CreateRule />
              </EntryPoint>
            }
          />
          <Route
            path="/rule/edit/:ruleId"
            element={
              <EntryPoint path="/rule/edit/:ruleId">
                <CreateRule />
              </EntryPoint>
            }
          />
          <Route
            path="/subscription/update"
            element={
              <EntryPoint path="/subscription/update">
                <SubscriptionUpdate />
              </EntryPoint>
            }
          />
          <Route
            path="/subscribe"
            element={
              <EntryPoint path="/subscribe">
                <Subscribe />
              </EntryPoint>
            }
          />
          <Route
            path="/delete-account"
            element={
              <EntryPoint path="/delete-account">
                <DeleteAccount />
              </EntryPoint>
            }
          />
        </Routes>
      </main>
      <UpdateMessageBanner />
    </BrowserRouter>
  );

  return user ? <Dashboard /> : <LoginForm />;
};

// Root Component with Auth Provider
const App: React.FC = () => {
  useEffect(() => {
    // Load saved theme and font on app startup
    loadSavedTheme();
    loadSavedFont();
  }, []);

  return (
    <AuthProvider>
      <InnerApp />
    </AuthProvider>
  );
};

export default App;
